import { SaveCompanyContact } from './SaveCompanyContact.model';

export class SaveAccountPage {
    UserName: string | undefined;
    Password: string | undefined;
    Contacts: SaveCompanyContact[] | undefined;
}



// WEBPACK FOOTER //
// ./src/app/models/SaveAccountPage.model.ts